// extracted by mini-css-extract-plugin
module.exports = {"item":"Tag_item__0hGuv","largeItem":"Tag_largeItem__hrrwN","itemContent":"Tag_itemContent__Pxwpg","itemRemove":"Tag_itemRemove__9cr6J"};